import * as types from './mutation-types';

const makeAction =
  (type) =>
  ({ commit }, ...args) =>
    commit(type, ...args);

const actions = {
  // ACCOUNT
  updateAccountName: makeAction(types.UPDATE_ACCOUNT_NAME),

  // ADVANCED REPORT EXECUTIONS
  updateAdvancedReportExecutionType: makeAction(types.UPDATE_ADVANCEDREPORTEXECUTION_TYPE),
  updateAdvancedReportExecutionBreakdown: makeAction(types.UPDATE_ADVANCEDREPORTEXECUTION_BREAKDOWN),
  updateAdvancedReportExecutionDates: makeAction(types.UPDATE_ADVANCEDREPORTEXECUTION_DATES),
  updateAdvancedReportExecutionTimezone: makeAction(types.UPDATE_ADVANCEDREPORTEXECUTION_TIMEZONE),
  updateAdvancedReportExecutionEmails: makeAction(types.UPDATE_ADVANCEDREPORTEXECUTION_EMAILS),

  // ADVANCED REPORT SCHEDULES
  updateAdvancedReportScheduleReportType: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_REPORTTYPE),
  updateAdvancedReportScheduleReportParameters: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_REPORTPARAMETERS),
  updateAdvancedReportScheduleExecutionTimezone: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_EXECUTIONTIMEZONE),
  updateAdvancedReportScheduleFirstEvent: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_FIRSTEVENT),
  updateAdvancedReportScheduleLastEvent: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_LASTEVENT),
  updateAdvancedReportScheduleRecurringPeriod: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_RECURRINGPERIOD),
  updateAdvancedReportScheduleDayOfMonth: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_DAYOFMONTH),
  updateAdvancedReportScheduleNotificationEmails: makeAction(types.UPDATE_ADVANCEDREPORTSCHEDULE_NOTIFICATIONS),

  // ADVERTISER
  updateAdvertiserDomain: makeAction(types.UPDATE_ADVERTISER_DOMAIN),
  updateAdvertiserMinSecondsBetweenPlays: makeAction(types.UPDATE_ADVERTISER_MINSECONDSBETWEENPLAYS),
  updateAdvertiserName: makeAction(types.UPDATE_ADVERTISER_NAME),

  // AUDIENCE FILES
  updateAudienceFileName: makeAction(types.UPDATE_AUDIENCEFILE_NAME),

  // AUDIENCE LOGIC
  updateAudienceLogicAudienceRules: makeAction(types.UPDATE_AUDIENCELOGIC_AUDIENCERULES),
  updateAudienceLogicDataProviderID: makeAction(types.UPDATE_AUDIENCELOGIC_DATAPROVIDERID),
  updateAudienceLogicDataMarketplaceID: makeAction(types.UPDATE_AUDIENCELOGIC_DATAMARKETPLACEID),
  updateAudienceLogicExternalDemographicIDs: makeAction(types.UPDATE_AUDIENCELOGIC_EXTERNALDEMOGRAPHICIDS),
  updateAudienceLogicLogicalExpression: makeAction(types.UPDATE_AUDIENCELOGIC_LOGICALEXPRESSION),
  updateAudienceLogicName: makeAction(types.UPDATE_AUDIENCELOGIC_NAME),
  updateAudienceLookBackWindowCandidateFrequency: makeAction(types.UPDATE_AUDIENCELOOKBACKWINDOW_CANDIDATEFREQUENCY),
  updateAudienceLookBackWindowFromDate: makeAction(types.UPDATE_AUDIENCELOOKBACKWINDOW_FROMDATE),
  updateAudienceLookBackWindowIsRelative: makeAction(types.UPDATE_AUDIENCELOOKBACKWINDOW_ISRELATIVE),
  updateAudienceLookBackWindowPeriodType: makeAction(types.UPDATE_AUDIENCELOOKBACKWINDOW_PERIODTYPE),
  updateAudienceLookBackWindowTimePeriod: makeAction(types.UPDATE_AUDIENCELOOKBACKWINDOW_TIMEPERIOD),
  updateAudienceLookBackWindowToDate: makeAction(types.UPDATE_AUDIENCELOOKBACKWINDOW_TODATE),
  updateAudienceRuleDaypart: makeAction(types.UPDATE_AUDIENCERULE_DAYPART),
  updateAudienceRuleExternalDemographicID: makeAction(types.UPDATE_AUDIENCERULE_EXTERNALDEMOGRAPHICID),
  updateAudienceRuleGeofenceGroupID: makeAction(types.UPDATE_AUDIENCERULE_GEOFENCEGROUPID),
  updateAudienceRuleIsCustomDaypart: makeAction(types.UPDATE_AUDIENCERULE_ISCUSTOMDAYPART),
  updateAudienceRuleIsNegated: makeAction(types.UPDATE_AUDIENCERULE_ISNEGATED),
  updateAudienceGroupOperator: makeAction(types.UPDATE_AUDIENCEGROUP_OPERATOR),
  updateAudienceRuleKey: makeAction(types.UPDATE_AUDIENCERULE_KEY),
  updateAudienceRuleSegments: makeAction(types.UPDATE_AUDIENCERULE_SEGMENTS),
  updateAudienceRuleLookbackWindows: makeAction(types.UPDATE_AUDIENCERULE_LOOKBACKWINDOWS),
  updateAudienceRuleName: makeAction(types.UPDATE_AUDIENCERULE_NAME),
  updateAudienceRuleCustomGroup: makeAction(types.UPDATE_AUDIENCERULE_CUSTOM_GROUP),
  updateAudienceRuleCustomGroupName: makeAction(types.UPDATE_AUDIENCERULE_CUSTOM_GROUP_NAME),
  updateAudienceRuleCustomGroupS3Path: makeAction(types.UPDATE_AUDIENCERULE_CUSTOM_GROUP_S3PATH),
  updateAudienceRuleDataProviderID: makeAction(types.UPDATE_AUDIENCERULE_DATAPROVIDER_ID),
  updateNodeOperator: makeAction(types.UPDATE_NODE_OPERATOR),
  updateNodes: makeAction(types.UPDATE_NODES),

  // CAMPAIGNS
  updateCampaignAccountID: makeAction(types.UPDATE_CAMPAIGN_ACCOUNT_ID),
  updateCampaignAdvertiserID: makeAction(types.UPDATE_CAMPAIGN_ADVERTISER_ID),
  updateCampaignBudget: makeAction(types.UPDATE_CAMPAIGN_BUDGET),
  updateCampaignBudgetCap: makeAction(types.UPDATE_CAMPAIGN_BUDGET_CAP),
  updateCampaignDailyCap: makeAction(types.UPDATE_CAMPAIGN_DAILYCAP),
  updateCampaignEndDate: makeAction(types.UPDATE_CAMPAIGN_ENDDATE),
  updateCampaignFlights: makeAction(types.UPDATE_CAMPAIGN_FLIGHTS),
  updateCampaignInsertionOrderBudget: makeAction(types.UPDATE_CAMPAIGN_INSERTION_ORDER_BUDGET),
  updateCampaignInternalProperties: makeAction(types.UPDATE_CAMPAIGN_INTERNAL_PROPERTIES),
  updateCampaignLineItems: makeAction(types.UPDATE_CAMPAIGN_LINE_ITEMS),
  updateCampaignMargins: makeAction(types.UPDATE_CAMPAIGN_MARGINS),
  updateCampaignMinSecondsBetweenPlays: makeAction(types.UPDATE_CAMPAIGN_MINSECONDSBETWEENPLAYS),
  updateCampaignName: makeAction(types.UPDATE_CAMPAIGN_NAME),
  updateCampaignNotes: makeAction(types.UPDATE_CAMPAIGN_NOTES),
  updateCampaignPacingBudget: makeAction(types.UPDATE_CAMPAIGN_PACINGBUDGET),
  updateCampaignPacingBudgetMode: makeAction(types.UPDATE_CAMPAIGN_PACINGBUDGETMODE),
  updateCampaignPacingModifiedAt: makeAction(types.UPDATE_CAMPAIGN_PACINGMODIFIEDAT),
  updateCampaignPacingStrategy: makeAction(types.UPDATE_CAMPAIGN_PACINGSTRATEGY),
  updateCampaignPlanID: makeAction(types.UPDATE_CAMPAIGN_PLAN_ID),
  updateCampaignPriority: makeAction(types.UPDATE_CAMPAIGN_PRIORITY),
  updateCampaignProperties: makeAction(types.UPDATE_CAMPAIGN_PROPERTIES),
  updateCampaignReachAndFrequencyRequested: makeAction(types.UPDATE_CAMPAIGN_REACH_AND_FREQUENCY_REQUESTED),
  updateCampaignSharedEntity: makeAction(types.UPDATE_CAMPAIGN_SHAREDENTITY),
  updateCampaignStartDate: makeAction(types.UPDATE_CAMPAIGN_STARTDATE),
  updateCampaignType: makeAction(types.UPDATE_CAMPAIGN_TYPE),
  updateCampaignIsTest: makeAction(types.UPDATE_CAMPAIGN_IS_TEST),
  updateCampaignAdvertiserBudget: makeAction(types.UPDATE_CAMPAIGN_ADVERTISER_BUDGET),

  // CREATIVES
  updateCreativeAdvertiserID: makeAction(types.UPDATE_CREATIVE_ADVERTISER_ID),
  updateCreativeApprovalComment: makeAction(types.UPDATE_CREATIVE_APPROVAL_COMMENT),
  updateCreativeCreativeFormatExclusions: makeAction(types.UPDATE_CREATIVE_CREATIVEFORMATEXCLUSIONS),
  updateCreativeCreativeFormats: makeAction(types.UPDATE_CREATIVE_CREATIVEFORMATS),
  updateCreativeCreativeOrientations: makeAction(types.UPDATE_CREATIVE_CREATIVEORIENTATIONS),
  updateCreativeCreativeOrientationExclusions: makeAction(types.UPDATE_CREATIVE_CREATIVEORIENTATIONEXCLUSIONS),
  updateCreativeCreativeProperties: makeAction(types.UPDATE_CREATIVE_CREATIVEPROPERTIES),
  updateCreativeCreativeTrackingUrls: makeAction(types.UPDATE_CREATIVE_CREATIVETRACKINGURLS),
  updateCreativeCreativeType: makeAction(types.UPDATE_CREATIVE_CREATIVETYPE),

  updateCreativeDaypart: makeAction(types.UPDATE_CREATIVE_DAYPART),
  updateCreativePreciseDaypart: makeAction(types.UPDATE_CREATIVE_PRECISE_DAYPART),
  updateCreativeGeofenceGroupIDs: makeAction(types.UPDATE_CREATIVE_GEOFENCE_GROUP_IDS),
  updateCreativeGeofenceGroupExclusionIDs: makeAction(types.UPDATE_CREATIVE_GEOFENCE_GROUP_EXCLUSION_IDS),
  updateCreativeIABCategories: makeAction(types.UPDATE_CREATIVE_IAB_CATEGORY_IDS),
  updateCreativeIsFallback: makeAction(types.UPDATE_CREATIVE_IS_FALLBACK),
  updateCreativeIsMobile: makeAction(types.UPDATE_CREATIVE_IS_MOBILE),
  updateCreativeLanguages: makeAction(types.UPDATE_CREATIVE_LANGUAGE_IDS),
  updateCreativeLocationIDs: makeAction(types.UPDATE_CREATIVE_LOCATIONIDS),
  updateCreativeLocationExclusionIDs: makeAction(types.UPDATE_CREATIVE_LOCATIONEXCLUSIONIDS),
  updateCreativeMarketIDs: makeAction(types.UPDATE_CREATIVE_MARKET_IDS),
  updateCreativeMarketExclusionIDs: makeAction(types.UPDATE_CREATIVE_MARKETEXCLUSIONIDS),
  updateCreativeMatchingCreativeSizes: makeAction(types.UPDATE_CREATIVE_MATCHING_CREATIVE_SIZES),
  updateCreativeMediaTypeIDs: makeAction(types.UPDATE_CREATIVE_MEDIATYPEIDS),
  updateCreativeMediaTypeExclusionIDs: makeAction(types.UPDATE_CREATIVE_MEDIATYPEEXCLUSIONIDS),
  updateCreativeMissingCreativeSizes: makeAction(types.UPDATE_CREATIVE_MISSING_CREATIVE_SIZES),
  updateCreativeName: makeAction(types.UPDATE_CREATIVE_NAME),
  updateCreativeNetworkIDs: makeAction(types.UPDATE_CREATIVE_NETWORKIDS),
  updateCreativeNetworkExclusionIDs: makeAction(types.UPDATE_CREATIVE_NETWORKEXCLUSIONIDS),
  updateCreativeOverrideDefaultDuration: makeAction(types.UPDATE_CREATIVE_OVERRIDEDEFAULTDURATION),
  updateCreativeRunState: makeAction(types.UPDATE_CREATIVE_RUNSTATE),
  updateCreativeSiteIDs: makeAction(types.UPDATE_CREATIVE_SITEIDS),
  updateCreativeSiteExclusionIDs: makeAction(types.UPDATE_CREATIVE_SITEEXCLUSIONIDS),
  updateCreativeState: makeAction(types.UPDATE_CREATIVE_STATE),
  updateCreativeTargetingCriteria: makeAction(types.UPDATE_CREATIVE_TARGETING_CRITERIA),
  updateCreativeUnitIDs: makeAction(types.UPDATE_CREATIVE_UNITIDS),
  updateCreativeUnitExclusionIDs: makeAction(types.UPDATE_CREATIVE_UNITEXCLUSIONIDS),
  updateCreativeUnitTags: makeAction(types.UPDATE_CREATIVE_UNITTAGS),
  updateCreativeUnitTagExclusions: makeAction(types.UPDATE_CREATIVE_UNITTAGEXCLUSIONS),
  updateCreativeUnitPackIDs: makeAction(types.UPDATE_CREATIVE_UNITPACKIDS),
  updateCreativeUnitPackExclusionIDs: makeAction(types.UPDATE_CREATIVE_UNITPACKEXCLUSIONIDS),

  // DEMOGRAPHICS
  updateDemographicName: makeAction(types.UPDATE_DEMOGRAPHIC_NAME),

  // EXTERNAL EVENTS
  updateCustomEventCategoryName: makeAction(types.UPDATE_CUSTOM_EVENT_CATEGORYNAME),
  updateCustomEventCode: makeAction(types.UPDATE_CUSTOM_EVENT_CODE),
  updateCustomEventName: makeAction(types.UPDATE_CUSTOM_EVENT_NAME),

  // GEOFENCE GROUPS
  updateGeofenceExtrusion: makeAction(types.UPDATE_GEOFENCE_EXTRUSION),
  updateGeofenceGeofenceGroupID: makeAction(types.UPDATE_GEOFENCE_GEOFENCEGROUPID),
  updateGeofenceGeoJson: makeAction(types.UPDATE_GEOFENCE_GEOJSON),
  updateGeofenceGroupDescription: makeAction(types.UPDATE_GEOFENCE_GROUP_DESCRIPTION),
  updateGeofenceGroupGeofences: makeAction(types.UPDATE_GEOFENCE_GROUP_GEOFENCES),
  updateGeofenceGroupName: makeAction(types.UPDATE_GEOFENCE_GROUP_NAME),
  updateGeofenceGroupTags: makeAction(types.UPDATE_GEOFENCE_GROUP_TAGS),
  updateGeofenceIsPoint: makeAction(types.UPDATE_GEOFENCE_ISPOINT),
  updateGeofenceLat: makeAction(types.UPDATE_GEOFENCE_LAT),
  updateGeofenceLng: makeAction(types.UPDATE_GEOFENCE_LNG),
  updateGeofenceMapboxDrawID: makeAction(types.UPDATE_GEOFENCE_MAPBOXDRAWID),
  updateGeofenceRadius: makeAction(types.UPDATE_GEOFENCE_RADIUS),
  updateGeofenceRadiusUnit: makeAction(types.UPDATE_GEOFENCE_RADIUS_UNIT),
  updateGeofenceRadiusInUnit: makeAction(types.UPDATE_GEOFENCE_RADIUS_IN_UNIT),

  // LINEITEMS
  updateLineItemAdDuration: makeAction(types.UPDATE_LINEITEM_ADDURATION),
  updateLineItemAdvertiserBudget: makeAction(types.UPDATE_LINEITEM_ADVERTISER_BUDGET),
  updateLineItemApprovalComment: makeAction(types.UPDATE_LINEITEM_APPROVAL_COMMENT),
  updateLineItemAttachedMeasurements: makeAction(types.UPDATE_LINEITEM_ATTACHED_MEASUREMENTS),
  updateLineItemBiddingType: makeAction(types.UPDATE_LINEITEM_BIDDING_TYPE),
  updateLineItemBudget: makeAction(types.UPDATE_LINEITEM_BUDGET),
  updateLineItemBudgetMode: makeAction(types.UPDATE_LINEITEM_BUDGET_MODE),
  updateLineItemBuyFromDealsEnabled: makeAction(types.UPDATE_LINEITEM_BUY_FROM_DEALS_ENABLED),
  updateLineItemCadence: makeAction(types.UPDATE_LINEITEM_CADENCE),
  updateLineItemCadenceSmoothCatchup: makeAction(types.UPDATE_LINEITEM_CADENCE_SMOOTH_CATCHUP),
  updateLineItemCampaign: makeAction(types.UPDATE_LINEITEM_CAMPAIGN),
  updateLineItemCampaignID: makeAction(types.UPDATE_LINEITEM_CAMPAIGN_ID),
  updateLineItemChannelType: makeAction(types.UPDATE_LINEITEM_CHANNEL_TYPE),
  updateLineItemCompanionGroupName: makeAction(types.UPDATE_LINEITEM_COMPANION_GROUP_NAME),
  updateLineItemCompanionOrder: makeAction(types.UPDATE_LINEITEM_COMPANION_ORDER),
  updateLineItemCPM: makeAction(types.UPDATE_LINEITEM_CPM),
  updateLineItemCpmCalculator: makeAction(types.UPDATE_LINEITEM_CPM_CALCULATOR),
  updateLineItemCreativeFormatExclusions: makeAction(types.UPDATE_LINEITEM_CREATIVEFORMATEXCLUSIONS),
  updateLineItemCreativeFormats: makeAction(types.UPDATE_LINEITEM_CREATIVEFORMATS),
  updateLineItemCreativeIDs: makeAction(types.UPDATE_LINEITEM_CREATIVEIDS),
  updateLineItemCreativeOrientationExclusions: makeAction(types.UPDATE_LINEITEM_CREATIVEORIENTATIONEXCLUSIONS),
  updateLineItemCreativeOrientations: makeAction(types.UPDATE_LINEITEM_CREATIVEORIENTATIONS),
  updateLineItemDailyGoalCap: makeAction(types.UPDATE_LINEITEM_DAILY_GOAL_CAP),
  updateLineItemDaypart: makeAction(types.UPDATE_LINEITEM_DAYPART),
  updateLineItemDeliveryCurve: makeAction(types.UPDATE_LINEITEM_DELIVERY_CURVE),
  updateLineItemDeliveryMode: makeAction(types.UPDATE_LINEITEM_DELIVERY_MODE),
  updateLineItemDemographicIDs: makeAction(types.UPDATE_LINEITEM_DEMOGRAPHICIDS),
  updateLineItemDiscounts: makeAction(types.UPDATE_LINEITEM_DISCOUNTS),
  updateLineItemEndDate: makeAction(types.UPDATE_LINEITEM_ENDDATE),
  updateLineItemEntityFees: makeAction(types.UPDATE_LINEITEM_ENTITY_FEES),
  updateLineItemEstimatedAudienceCPM: makeAction(types.UPDATE_LINEITEM_ESTIMATED_AUDIENCE_CPM),
  updateLineItemEstimatedAverageAudienceCPM: makeAction(types.UPDATE_LINEITEM_ESTIMATED_AVERAGE_AUDIENCE_CPM),
  updateLineItemEstimatedAverageCPM: makeAction(types.UPDATE_LINEITEM_ESTIMATED_AVERAGE_CPM),
  updateLineItemEstimatedCPM: makeAction(types.UPDATE_LINEITEM_ESTIMATED_CPM),
  updateLineItemExchangeFeeOverrideType: makeAction(types.UPDATE_EXCHANGE_FEE_OVERRIDE_TYPE),
  updateLineItemExchangeFeeOverrideValue: makeAction(types.UPDATE_EXCHANGE_FEE_OVERRIDE_VALUE),
  updateLineItemExternalID: makeAction(types.UPDATE_LINEITEM_EXTERNAL_ID),
  updateLineItemFlightRatio: makeAction(types.UPDATE_LINEITEM_FLIGHT_RATIO),
  updateLineItemGeofenceGroupExclusionIDs: makeAction(types.UPDATE_LINEITEM_GEOFENCE_GROUP_EXCLUSION_IDS),
  updateLineItemGeofenceGroupIDs: makeAction(types.UPDATE_LINEITEM_GEOFENCE_GROUP_IDS),
  updateLineItemHasInfiniteBudget: makeAction(types.UPDATE_LINEITEM_HAS_INFINITE_BUDGET),
  updateLineItemIabCategories: makeAction(types.UPDATE_LINEITEM_IABCATEGORIES),
  updateLineItemIabCategoryExclusions: makeAction(types.UPDATE_LINEITEM_IABCATEGORYEXCLUSIONS),
  updateLineItemID: makeAction(types.UPDATE_LINEITEM_ID),
  updateLineItemIsCPMFromRateCard: makeAction(types.UPDATE_LINEITEM_IS_CPM_FROM_RATE_CARD),
  updateLineItemIsMeasurementRequested: makeAction(types.UPDATE_LINEITEM_IS_MEASUREMENT_REQUESTED),
  updateLineItemLanguageExclusionIDs: makeAction(types.UPDATE_LINEITEM_LANGUAGEEXCLUSIONIDS),
  updateLineItemLanguageIDs: makeAction(types.UPDATE_LINEITEM_LANGUAGEIDS),
  updateLineItemLocationExclusionIDs: makeAction(types.UPDATE_LINEITEM_LOCATIONEXCLUSIONIDS),
  updateLineItemLocationIDs: makeAction(types.UPDATE_LINEITEM_LOCATIONIDS),
  updateLineItemMargins: makeAction(types.UPDATE_LINEITEM_MARGINS),
  updateLineItemMarketExclusionIDs: makeAction(types.UPDATE_LINEITEM_MARKETEXCLUSIONIDS),
  updateLineItemMarketIDs: makeAction(types.UPDATE_LINEITEM_MARKET_IDS),
  updateLineItemMaxBidCPM: makeAction(types.UPDATE_LINEITEM_MAXBIDCPM),
  updateLineItemMinBidCPM: makeAction(types.UPDATE_LINEITEM_MINBIDCPM),
  updateLineItemMediaOwnerIDs: makeAction(types.UPDATE_LINEITEM_MEDIAOWNERIDS),
  updateLineItemMediaTypeExclusionIDs: makeAction(types.UPDATE_LINEITEM_MEDIATYPEEXCLUSIONIDS),
  updateLineItemMediaTypeIDs: makeAction(types.UPDATE_LINEITEM_MEDIATYPEIDS),
  updateLineItemMinConcentrationFactor: makeAction(types.UPDATE_LINEITEM_MIN_CONCENTRATION_FACTOR),
  updateLineItemMinConcentrationValue: makeAction(types.UPDATE_LINEITEM_MIN_CONCENTRATION_VALUE),
  updateLineItemMinSecondsBetweenPlays: makeAction(types.UPDATE_LINEITEM_MINSECONDSBETWEENPLAYS),
  updateLineItemMissingCreativeSizes: makeAction(types.UPDATE_LINEITEM_MISSING_CREATIVE_SIZES),
  updateLineItemName: makeAction(types.UPDATE_LINEITEM_NAME),
  updateLineItemNetworkExclusionIDs: makeAction(types.UPDATE_LINEITEM_NETWORKEXCLUSIONIDS),
  updateLineItemNetworkFrequencyCaps: makeAction(types.UPDATE_LINEITEM_NETWORKFREQUENCYCAPS),
  updateLineItemNetworkIDs: makeAction(types.UPDATE_LINEITEM_NETWORKIDS),
  updateLineItemNotes: makeAction(types.UPDATE_LINEITEM_NOTES),
  updateLineItemPackage: makeAction(types.UPDATE_LINEITEM_PACKAGE),
  updateLineItemPackageGroupDealsIDs: makeAction(types.UPDATE_LINEITEM_PACKAGEGROUP_DEALS),
  updateLineItemPackageGroupID: makeAction(types.UPDATE_LINEITEM_PACKAGEGROUP_ID),
  updateLineItemPackageID: makeAction(types.UPDATE_LINEITEM_PACKAGE_ID),
  updateLineItemPostalCodesFiles: makeAction(types.UPDATE_LINEITEM_POSTAL_CODES_FILES),
  updateLineItemPriority: makeAction(types.UPDATE_LINEITEM_PRIORITY),
  updateLineItemProductIDs: makeAction(types.UPDATE_LINEITEM_PRODUCTIDS),
  updateLineItemProperties: makeAction(types.UPDATE_LINEITEM_PROPERTIES),
  updateLineItemPurchaseType: makeAction(types.UPDATE_LINEITEM_PURCHASE_TYPE),
  updateLineItemRunState: makeAction(types.UPDATE_LINEITEM_RUNSTATE),
  updateLineItemSiteExclusionIDs: makeAction(types.UPDATE_LINEITEM_SITEEXCLUSIONIDS),
  updateLineItemSiteIDs: makeAction(types.UPDATE_LINEITEM_SITEIDS),
  updateLineItemStartDate: makeAction(types.UPDATE_LINEITEM_STARTDATE),
  updateLineItemState: makeAction(types.UPDATE_LINEITEM_STATE),
  updateLineItemTargetImpressions: makeAction(types.UPDATE_LINEITEM_TARGETIMPRESSIONS),
  updateLineItemTargetingCriteria: makeAction(types.UPDATE_LINEITEM_TARGETING_CRITERIA),
  updateLineItemTimestamp: makeAction(types.UPDATE_LINEITEM_TIMESTAMP),
  updateLineItemUnitExclusionIDs: makeAction(types.UPDATE_LINEITEM_UNITEXCLUSIONIDS),
  updateLineItemUnitIDs: makeAction(types.UPDATE_LINEITEM_UNITIDS),
  updateLineItemUnitPackExclusionIDs: makeAction(types.UPDATE_LINEITEM_UNITPACKEXCLUSIONIDS),
  updateLineItemUnitPackIDs: makeAction(types.UPDATE_LINEITEM_UNITPACKIDS),
  updateLineItemUnitTagExclusions: makeAction(types.UPDATE_LINEITEM_UNITTAGEXCLUSIONS),
  updateLineItemUnitTags: makeAction(types.UPDATE_LINEITEM_UNITTAGS),
  updateLineItemAddFeatureKey: makeAction(types.UPDATE_LINEITEM_ADD_FEATURE_KEY),
  updateLineItemRemoveFeatureKey: makeAction(types.UPDATE_LINEITEM_REMOVE_FEATURE_KEY),
  updateLineItemIsOfflineEnabled: makeAction(types.UPDATE_LINEITEM_IS_OFFLINE_ENABLED),

  // MARGINS
  updateMarginName: makeAction(types.UPDATE_MARGIN_NAME),

  // MOBILE LINEITEMS
  updateMobileLineItemName: makeAction(types.UPDATE_MOBILE_LINEITEM_NAME),
  updateMobileLineItemCampaignID: makeAction(types.UPDATE_MOBILE_LINEITEM_CAMPAIGN_ID),
  updateMobileLineItemStartDate: makeAction(types.UPDATE_MOBILE_LINEITEM_START_DATE),
  updateMobileLineItemEndDate: makeAction(types.UPDATE_MOBILE_LINEITEM_END_DATE),
  updateMobileLineItemBudget: makeAction(types.UPDATE_MOBILE_LINEITEM_BUDGET),
  updateMobileLineItemUseLineItemGeoTargeting: makeAction(types.UPDATE_MOBILE_LINEITEM_USE_LINEITEM_GEO_TARGETING),
  updateMobileLineItemCreatives: makeAction(types.UPDATE_MOBILE_LINEITEM_CREATIVES),
  updateMobileLineItemCreativeIDs: makeAction(types.UPDATE_MOBILE_LINEITEM_CREATIVE_IDS),
  updateMobileLineItemLineItems: makeAction(types.UPDATE_MOBILE_LINEITEM_LINEITEMS),
  updateMobileLineItemLineItemIDs: makeAction(types.UPDATE_MOBILE_LINEITEM_LINEITEM_IDS),
  updateMobileLineItemState: makeAction(types.UPDATE_MOBILE_LINEITEM_STATE),
  updateMobileLineItemNotes: makeAction(types.UPDATE_MOBILE_LINEITEM_NOTES),
  updateMobileLineItemMaxBidCPM: makeAction(types.UPDATE_MOBILE_LINEITEM_MAX_BID_CPM),
  updateMobileLineItemFreqCapCount: makeAction(types.UPDATE_MOBILE_LINEITEM_FREQ_CAP_COUNT),
  updateMobileLineItemFreqCapPeriod: makeAction(types.UPDATE_MOBILE_LINEITEM_FREQ_CAP_PERIOD),
  updateMobileLineItemFormat: makeAction(types.UPDATE_MOBILE_LINEITEM_FORMAT),
  updateMobileLineItemGoal: makeAction(types.UPDATE_MOBILE_LINEITEM_GOAL),

  // NETWORKS
  updateNetworkName: makeAction(types.UPDATE_NETWORK_NAME),
  updateNetworkCode: makeAction(types.UPDATE_NETWORK_CODE),

  // ORGANIZATIONCUSTOMFIELDS
  updateOrganizationCustomFieldName: makeAction(types.UPDATE_ORGANIZATIONCUSTOMFIELD_NAME),
  updateOrganizationCustomFieldKey: makeAction(types.UPDATE_ORGANIZATIONCUSTOMFIELD_KEY),
  updateOrganizationCustomFieldType: makeAction(types.UPDATE_ORGANIZATIONCUSTOMFIELD_TYPE),
  updateOrganizationCustomFieldIsRequired: makeAction(types.UPDATE_ORGANIZATIONCUSTOMFIELD_IS_REQUIRED),

  // ORGANIZATIONCUSTOMFIELDS
  updateOwnerYieldManagerSspName: makeAction(types.UPDATE_OWNER_YIELD_MANAGER_SSP_NAME),
  updateOwnerYieldManagerSspDomain: makeAction(types.UPDATE_OWNER_YIELD_MANAGER_SSP_DOMAIN),
  updateOwnerYieldManagerSspResponseTimeout: makeAction(types.UPDATE_OWNER_YIELD_MANAGER_SSP_RESPONSETIMEOUT),
  updateOwnerYieldManagerSspNotes: makeAction(types.UPDATE_OWNER_YIELD_MANAGER_SSP_NOTES),
  updateOwnerYieldManagerSspIsActive: makeAction(types.UPDATE_OWNER_YIELD_MANAGER_SSP_ISACTIVE),
  updateOwnerYieldManagerSspApiKey: makeAction(types.UPDATE_OWNER_YIELD_MANAGER_SSP_APIKEY),

  // PACKAGES
  updatePackageAdDurationMax: makeAction(types.UPDATE_PACKAGE_AD_DURATION_MAX),
  updatePackageAdDurationMin: makeAction(types.UPDATE_PACKAGE_AD_DURATION_MIN),
  updatePackageAdDurationOverridable: makeAction(types.UPDATE_PACKAGE_AD_DURATION_OVERRIDABLE),
  updatePackageAuctionType: makeAction(types.UPDATE_PACKAGE_AUCTION_TYPE),
  updatePackageBudgetMax: makeAction(types.UPDATE_PACKAGE_BUDGET_MAX),
  updatePackageBudgetMin: makeAction(types.UPDATE_PACKAGE_BUDGET_MIN),
  updatePackageBudgetMode: makeAction(types.UPDATE_PACKAGE_BUDGET_MODE),
  updatePackageBudgetOverridable: makeAction(types.UPDATE_PACKAGE_BUDGET_OVERRIDABLE),
  updatePackageBuyerExternalIDs: makeAction(types.UPDATE_PACKAGE_BUYER_EXTERNAL_IDS),
  updatePackageBuyerExternalExchangeIDs: makeAction(types.UPDATE_PACKAGE_BUYER_EXTERNAL_EXCHANGE_IDS),
  updatePackageBuyerOrganizationDSPIDs: makeAction(types.UPDATE_PACKAGE_BUYER_ORGANIZATION_DSP_IDS),
  updatePackageBuyerOrganizationDSPs: makeAction(types.UPDATE_PACKAGE_BUYER_ORGANIZATION_DSPS),
  updatePackageCadenceMax: makeAction(types.UPDATE_PACKAGE_CADENCE_MAX),
  updatePackageCadenceMin: makeAction(types.UPDATE_PACKAGE_CADENCE_MIN),
  updatePackageCadenceSmoothCatchup: makeAction(types.UPDATE_PACKAGE_CADENCE_SMOOTH_CATCHUP),
  updatePackageCo2EmissionsScoreThreshold: makeAction(types.UPDATE_PACKAGE_CO2_EMISSIONS_SCORE_THRESHOLD),
  updatePackageCpmFixed: makeAction(types.UPDATE_PACKAGE_CPM_FIXED),
  updatePackageCreativeFormatExclusions: makeAction(types.UPDATE_PACKAGE_CREATIVEFORMATEXCLUSIONS),
  updatePackageCreativeFormats: makeAction(types.UPDATE_PACKAGE_CREATIVEFORMATS),
  updatePackageCreativeOrientations: makeAction(types.UPDATE_PACKAGE_CREATIVEORIENTATIONS),
  updatePackageCreativeOrientationExclusions: makeAction(types.UPDATE_PACKAGE_CREATIVEORIENTATIONEXCLUSIONS),
  updatePackageCustomEventTargetingOverridable: makeAction(types.UPDATE_PACKAGE_CUSTOM_EVENT_TARGETING_OVERRIDABLE),
  updatePackageCuratorOrganizationIDs: makeAction(types.UPDATE_PACKAGE_CURATOR_ORGANIZATION_IDS),
  updatePackageDaypart: makeAction(types.UPDATE_PACKAGE_DAYPART),
  updatePackageDaypartOverridable: makeAction(types.UPDATE_PACKAGE_DAYPART_OVERRIDABLE),
  updatePackageDealID: makeAction(types.UPDATE_PACKAGE_DEALID),
  updatePackageDeliveryStats: makeAction(types.UPDATE_PACKAGE_DELIVERY_STATS),
  updatePackageDirectBilling: makeAction(types.UPDATE_PACKAGE_DIRECT_BILLING),
  updatePackageDemographicIDs: makeAction(types.UPDATE_PACKAGE_DEMOGRAPHIC_TARGET_IDS),
  updatePackageDemographicsOverridable: makeAction(types.UPDATE_PACKAGE_DEMOGRAPHIC_TARGETS_OVERRIDABLE),
  updatePackageEndDate: makeAction(types.UPDATE_PACKAGE_ENDDATE),
  updatePackageEstimatedAudienceCPM: makeAction(types.UPDATE_PACKAGE_ESTIMATED_AUDIENCE_CPM),
  updatePackageEstimatedAverageAudienceCPM: makeAction(types.UPDATE_PACKAGE_ESTIMATED_AVERAGE_AUDIENCE_CPM),
  updatePackageEstimatedAverageCPM: makeAction(types.UPDATE_PACKAGE_ESTIMATED_AVERAGE_CPM),
  updatePackageEstimatedCPM: makeAction(types.UPDATE_PACKAGE_ESTIMATED_CPM),
  updatePackageEntityFees: makeAction(types.UPDATE_PACKAGE_ENTITY_FEES),
  updatePackageGeofenceGroupIDs: makeAction(types.UPDATE_PACKAGE_GEOFENCE_GROUP_IDS),
  updatePackageGeofenceGroupExclusionIDs: makeAction(types.UPDATE_PACKAGE_GEOFENCE_GROUP_EXCLUSION_IDS),
  updatePackageHideUnitInformationInBidRequests: makeAction(types.UPDATE_PACKAGE_HIDE_UNIT_INFORMATION_IN_BID_REQUESTS),
  updatePackageIabCategories: makeAction(types.UPDATE_PACKAGE_IABCATEGORIES),
  updatePackageIabCategoryExclusions: makeAction(types.UPDATE_PACKAGE_IABCATEGORYEXCLUSIONS),
  updatePackageID: makeAction(types.UPDATE_PACKAGE_ID),
  updatePackageImpressionsMax: makeAction(types.UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_MAX),
  updatePackageImpressionsMin: makeAction(types.UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_MIN),
  updatePackageImpressionsOverridable: makeAction(types.UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_OVERRIDABLE),
  updatePackageIsCPMFromRateCard: makeAction(types.UPDATE_PACKAGE_CPM_FROM_RATE_CARD),
  updatePackageIsEvergreen: makeAction(types.UPDATE_PACKAGE_IS_EVERGREEN),
  updatePackageIsForBidding: makeAction(types.UPDATE_PACKAGE_IS_FOR_BIDDING),
  updatePackageIsOpen: makeAction(types.UPDATE_PACKAGE_IS_OPEN),
  updatePackageLanguageExclusionIDs: makeAction(types.UPDATE_PACKAGE_LANGUAGE_EXCLUSION_IDS),
  updatePackageLanguageIDs: makeAction(types.UPDATE_PACKAGE_LANGUAGE_IDS),
  updatePackageLocationExclusionIDs: makeAction(types.UPDATE_PACKAGE_LOCATION_EXCLUSION_IDS),
  updatePackageLocationIDs: makeAction(types.UPDATE_PACKAGE_LOCATION_TARGET_IDS),
  updatePackageLocationsOverridable: makeAction(types.UPDATE_PACKAGE_LOCATION_TARGETS_OVERRIDABLE),
  updatePackageMarketIDs: makeAction(types.UPDATE_PACKAGE_MARKET_IDS),
  updatePackageMediaOwnerIDs: makeAction(types.UPDATE_PACKAGE_MEDIA_OWNER_IDS),
  updatePackageMediaTypeIDs: makeAction(types.UPDATE_PACKAGE_MEDIA_TYPE_IDS),
  updatePackageMediaTypesOverridable: makeAction(types.UPDATE_PACKAGE_MEDIA_TYPES_OVERRIDABLE),
  updatePackageMinConcentrationFactor: makeAction(types.UPDATE_PACKAGE_MIN_CONCENTRATION_FACTOR),
  updatePackageMinConcentrationValue: makeAction(types.UPDATE_PACKAGE_MIN_CONCENTRATION_VALUE),
  updatePackageMinSecondsBetweenPlaysMax: makeAction(types.UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_MAX),
  updatePackageMinSecondsBetweenPlaysMin: makeAction(types.UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_MIN),
  updatePackageMinSecondsBetweenPlaysOverridable: makeAction(
    types.UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_OVERRIDABLE,
  ),
  updatePackageName: makeAction(types.UPDATE_PACKAGE_NAME),
  updatePackageNetworkIDs: makeAction(types.UPDATE_PACKAGE_NETWORK_IDS),
  updatePackageNetworksOverridable: makeAction(types.UPDATE_PACKAGE_NETWORKS_OVERRIDABLE),
  updatePackageNotes: makeAction(types.UPDATE_PACKAGE_NOTES),
  updatePackageNumberOfDaysMax: makeAction(types.UPDATE_PACKAGE_NUMBER_OF_DAYS_MAX),
  updatePackageNumberOfDaysMin: makeAction(types.UPDATE_PACKAGE_NUMBER_OF_DAYS_MIN),
  updatePackageNumberOfDaysOverridable: makeAction(types.UPDATE_PACKAGE_NUMBER_OF_DAYS_OVERRIDABLE),
  updatePackageOrganizationID: makeAction(types.UPDATE_PACKAGE_ORGANIZATION_ID),
  updatePackagePackageIDs: makeAction(types.UPDATE_PACKAGE_PACKAGE_IDS),
  updatePackagePackages: makeAction(types.UPDATE_PACKAGE_PACKAGES),
  updatePackageProperties: makeAction(types.UPDATE_PACKAGE_PROPERTIES),
  updatePackagePurchaseType: makeAction(types.UPDATE_PACKAGE_PURCHASE_TYPE),
  updatePackagePurchaseTypeOverridable: makeAction(types.UPDATE_PACKAGE_PURCHASE_TYPE_OVERRIDABLE),
  updatePackageSiteExclusionIDs: makeAction(types.UPDATE_PACKAGE_SITE_EXCLUSION_IDS),
  updatePackageSiteIDs: makeAction(types.UPDATE_PACKAGE_SITE_IDS),
  updatePackageStartDate: makeAction(types.UPDATE_PACKAGE_STARTDATE),
  updatePackageState: makeAction(types.UPDATE_PACKAGE_STATE),
  updatePackageTargetingCriteria: makeAction(types.UPDATE_PACKAGE_TARGETING_CRITERIA),
  updatePackageTargetingCriteriaOverridable: makeAction(types.UPDATE_PACKAGE_TARGETING_CRITERIA_OVERRIDABLE),
  updatePackageTimestamp: makeAction(types.UPDATE_PACKAGE_TIMESTAMP),
  updatePackageUnitAssignmentsOverridable: makeAction(types.UPDATE_PACKAGE_UNIT_ASSIGNMENTS_OVERRIDABLE),
  updatePackageUnitExclusionIDs: makeAction(types.UPDATE_PACKAGE_UNIT_EXCLUSION_IDS),
  updatePackageUnitIDs: makeAction(types.UPDATE_PACKAGE_UNIT_IDS),
  updatePackageUnitPackExclusionIDs: makeAction(types.UPDATE_PACKAGE_UNITPACK_EXCLUSION_IDS),
  updatePackageUnitPackIDs: makeAction(types.UPDATE_PACKAGE_UNITPACK_IDS),
  updatePackageUnitTags: makeAction(types.UPDATE_PACKAGE_UNITTAGS),
  updatePackageUnitTagExclusions: makeAction(types.UPDATE_PACKAGE_UNITTAGEXCLUSIONS),
  updatePackagePlanID: makeAction(types.UPDATE_PACKAGE_PLAN_ID),
  updatePackageCurationType: makeAction(types.UPDATE_PACKAGE_CURATION_TYPE),
  updatePackageSpendSteering: makeAction(types.UPDATE_PACKAGE_SPEND_STEERING),

  // PLANS
  updatePlanAccountID: makeAction(types.UPDATE_PLAN_ACCOUNT_ID),
  updatePlanAdDuration: makeAction(types.UPDATE_PLAN_ADDURATION),
  updatePlanAdvertiserID: makeAction(types.UPDATE_PLAN_ADVERTISER_ID),
  updatePlanBreakdownType: makeAction(types.UPDATE_PLAN_BREAKDOWNTYPE),
  updatePlanBudget: makeAction(types.UPDATE_PLAN_BUDGET),
  updatePlanBudgetMode: makeAction(types.UPDATE_PLAN_BUDGET_MODE),
  updatePlanBuyFromDealsEnabled: makeAction(types.UPDATE_PLAN_BUY_FROM_DEALS_ENABLED),
  updatePlanCPM: makeAction(types.UPDATE_PLAN_CPM),
  updatePlanCreativeFormatExclusions: makeAction(types.UPDATE_PLAN_CREATIVEFORMATEXCLUSIONS),
  updatePlanCreativeFormats: makeAction(types.UPDATE_PLAN_CREATIVEFORMATS),
  updatePlanCreativeOrientations: makeAction(types.UPDATE_PLAN_CREATIVEORIENTATIONS),
  updatePlanCreativeOrientationExclusions: makeAction(types.UPDATE_PLAN_CREATIVEORIENTATIONEXCLUSIONS),
  updatePlanDaypart: makeAction(types.UPDATE_PLAN_DAYPART),
  updatePlanDemographicIDs: makeAction(types.UPDATE_PLAN_DEMOGRAPHIC_TARGET_IDS),
  updatePlanEndDate: makeAction(types.UPDATE_PLAN_ENDDATE),
  updatePlanEstimatedAudienceCPM: makeAction(types.UPDATE_PLAN_ESTIMATED_AUDIENCE_CPM),
  updatePlanEstimatedAverageAudienceCPM: makeAction(types.UPDATE_PLAN_ESTIMATED_AVERAGE_AUDIENCE_CPM),
  updatePlanEstimatedAverageCPM: makeAction(types.UPDATE_PLAN_ESTIMATED_AVERAGE_CPM),
  updatePlanEstimatedCPM: makeAction(types.UPDATE_PLAN_ESTIMATED_CPM),
  updatePlanGeofenceGroupIDs: makeAction(types.UPDATE_PLAN_GEOFENCE_GROUP_IDS),
  updatePlanGeofenceGroupExclusionIDs: makeAction(types.UPDATE_PLAN_GEOFENCE_GROUP_EXCLUSION_IDS),
  updatePlanGoal: makeAction(types.UPDATE_PLAN_GOAL),
  updatePlanHeatmaps: makeAction(types.UPDATE_PLAN_HEATMAPS),
  updatePlanIabCategories: makeAction(types.UPDATE_PLAN_IABCATEGORIES),
  updatePlanIabCategoryExclusions: makeAction(types.UPDATE_PLAN_IABCATEGORYEXCLUSIONS),
  updatePlanIsCPMFromRateCard: makeAction(types.UPDATE_PLAN_IS_CPM_FROM_RATE_CARD),
  updatePlanIsMeasurementRequested: makeAction(types.UPDATE_PLAN_IS_MEASUREMENT_REQUESTED),
  updatePlanLocationExclusionIDs: makeAction(types.UPDATE_PLAN_LOCATIONEXCLUSIONIDS),
  updatePlanLocationIDs: makeAction(types.UPDATE_PLAN_LOCATIONIDS),
  updatePlanMaxBidCPM: makeAction(types.UPDATE_PLAN_MAXBIDCPM),
  updatePlanMarketExclusionIDs: makeAction(types.UPDATE_PLAN_MARKETEXCLUSIONIDS),
  updatePlanMarketIDs: makeAction(types.UPDATE_PLAN_MARKET_IDS),
  updatePlanMediaOwnerIDs: makeAction(types.UPDATE_PLAN_MEDIA_OWNER_IDS),
  updatePlanMediaTypeExclusionIDs: makeAction(types.UPDATE_PLAN_MEDIATYPEEXCLUSIONIDS),
  updatePlanMediaTypeIDs: makeAction(types.UPDATE_PLAN_MEDIATYPEIDS),
  updatePlanMinConcentrationFactor: makeAction(types.UPDATE_PLAN_MIN_CONCENTRATION_FACTOR),
  updatePlanMinConcentrationValue: makeAction(types.UPDATE_PLAN_MIN_CONCENTRATION_VALUE),
  updatePlanMinSecondsBetweenPlays: makeAction(types.UPDATE_PLAN_MINSECONDSBETWEENPLAYS),
  updatePlanName: makeAction(types.UPDATE_PLAN_NAME),
  updatePlanNetworkExclusionIDs: makeAction(types.UPDATE_PLAN_NETWORKEXCLUSIONIDS),
  updatePlanNetworkFrequencyCaps: makeAction(types.UPDATE_PLAN_NETWORKFREQUENCYCAPS),
  updatePlanNetworkIDs: makeAction(types.UPDATE_PLAN_NETWORKIDS),
  updatePlanPackageGroupDealsIDs: makeAction(types.UPDATE_PLAN_PACKAGEGROUP_DEALS),
  updatePlanPackageGroupID: makeAction(types.UPDATE_PLAN_PACKAGEGROUP_ID),
  updatePlanPackage: makeAction(types.UPDATE_PLAN_PACKAGE),
  updatePlanPackageID: makeAction(types.UPDATE_PLAN_PACKAGE_ID),
  updatePlanPlanFee: makeAction(types.UPDATE_PLAN_PLANFEE),
  updatePlanProperties: makeAction(types.UPDATE_PLAN_PROPERTIES),
  updatePlanPurchaseType: makeAction(types.UPDATE_PLAN_PURCHASE_TYPE),
  updatePlanSiteExclusionIDs: makeAction(types.UPDATE_PLAN_SITEEXCLUSIONIDS),
  updatePlanSiteIDs: makeAction(types.UPDATE_PLAN_SITEIDS),
  updatePlanStartDate: makeAction(types.UPDATE_PLAN_STARTDATE),
  updatePlanTargetImpressions: makeAction(types.UPDATE_PLAN_TARGETIMPRESSIONS),
  updatePlanTargetingCriteria: makeAction(types.UPDATE_PLAN_TARGETING_CRITERIA),
  updatePlanTTDCampaign: makeAction(types.UPDATE_PLAN_TTD_CAMPAIGN),
  updatePlanUnitExclusionIDs: makeAction(types.UPDATE_PLAN_UNITEXCLUSIONIDS),
  updatePlanUnitIDs: makeAction(types.UPDATE_PLAN_UNITIDS),
  updatePlanUnitPackExclusionIDs: makeAction(types.UPDATE_PLAN_UNITPACKEXCLUSIONIDS),
  updatePlanUnitPackIDs: makeAction(types.UPDATE_PLAN_UNITPACKIDS),
  updatePlanJourneyID: makeAction(types.UPDATE_PLAN_JOURNEY_ID),

  // POSTAL CODES FILE
  updatePostalCodesFileName: makeAction(types.UPDATE_POSTAL_CODES_FILE_NAME),

  // PRESALE HEATMAPS
  updatePreSaleHeatmapDescription: makeAction(types.UPDATE_PRESALEHEATMAP_DESCRIPTION),
  updatePreSaleHeatmapJson: makeAction(types.UPDATE_PRESALEHEATMAP_JSON),
  updatePreSaleHeatmapName: makeAction(types.UPDATE_PRESALEHEATMAP_NAME),
  updatePreSaleHeatmapPublicPlaintextPassword: makeAction(types.UPDATE_PRESALEHEATMAP_PUBLIC_PLAINTEXT_PASSWORD),

  // DATA PROVIDER
  updateDataProviderExternalDemographics: makeAction(types.UPDATE_DATAPROVIDER_EXTERNALDEMOGRAPHICS),
  updateDataProviderSelectedExternalDemographics: makeAction(types.UPDATE_DATAPROVIDER_SELECTEDEXTERNALDEMOGRAPHICS),

  // REPORT DEFINITIONS
  updateReportDefinitionBreakdown: makeAction(types.UPDATE_REPORTDEFINITION_BREAKDOWN),
  updateReportDefinitionDates: makeAction(types.UPDATE_REPORTDEFINITION_DATES),
  updateReportDefinitionDimensions: makeAction(types.UPDATE_REPORTDEFINITION_DIMENSIONS),
  updateReportDefinitionEmailTargets: makeAction(types.UPDATE_REPORTDEFINITION_EMAILTARGETS),
  updateReportDefinitionFilters: makeAction(types.UPDATE_REPORTDEFINITION_FILTERS),
  updateReportDefinitionLastExecutedOn: makeAction(types.UPDATE_REPORTDEFINITION_LASTEXECUTED_ON),
  updateReportDefinitionMetrics: makeAction(types.UPDATE_REPORTDEFINITION_METRICS),
  updateReportDefinitionName: makeAction(types.UPDATE_REPORTDEFINITION_NAME),
  updateReportDefinitionPreferredRunnerType: makeAction(types.UPDATE_REPORTDEFINITION_PREFERRED_RUNNER_TYPE),
  updateReportDefinitionTimezone: makeAction(types.UPDATE_REPORTDEFINITION_TIMEZONE),
  updateReportDefinitionFormat: makeAction(types.UPDATE_REPORTDEFINITION_DEFINITION_FORMAT),
  updateReportDefinitionDefaultOutputFormat: makeAction(types.UPDATE_REPORTDEFINITION_DEFAULT_OUTPUT_FORMAT),
  updateReportDefinitionReportSchedules: makeAction(types.UPDATE_REPORTDEFINITION_REPORTSCHEDULES),

  // REPORT SCHEDULES
  updateReportScheduleDayOfMonth: makeAction(types.UPDATE_REPORTSCHEDULE_DAYOFMONTH),
  updateReportScheduleExecutionTimezone: makeAction(types.UPDATE_REPORTSCHEDULE_EXECUTIONTIMEZONE),
  updateReportScheduleFirstEvent: makeAction(types.UPDATE_REPORTSCHEDULE_FIRSTEVENT),
  updateReportScheduleLastEvent: makeAction(types.UPDATE_REPORTSCHEDULE_LASTEVENT),
  updateReportScheduleRecurringPeriod: makeAction(types.UPDATE_REPORTSCHEDULE_RECURRINGPERIOD),

  // SITES
  updateSiteActive: makeAction(types.UPDATE_SITE_ACTIVE),
  updateSiteDescription: makeAction(types.UPDATE_SITE_DESCRIPTION),
  updateSiteExternalID: makeAction(types.UPDATE_SITE_EXTERNALID),
  updateSiteIsActive: makeAction(types.UPDATE_SITE_ISACTIVE),
  updateSiteIsStreetViewImageAvailable: makeAction(types.UPDATE_SITE_ISSTREETVIEWIMAGEAVAILABLE),
  updateSiteLatitude: makeAction(types.UPDATE_SITE_LATITUDE),
  updateSiteLocationID: makeAction(types.UPDATE_SITE_LOCATIONID),
  updateSiteLongitude: makeAction(types.UPDATE_SITE_LONGITUDE),
  updateSiteName: makeAction(types.UPDATE_SITE_NAME),
  updateSiteUnits: makeAction(types.UPDATE_SITE_UNITS),

  // UNITS
  updateUnitAdServerAvailability: makeAction(types.UPDATE_UNIT_AD_SERVER_AVAILABLITY),
  updateUnitAllowHtml: makeAction(types.UPDATE_UNIT_ALLOWHTML),
  updateUnitAllowImage: makeAction(types.UPDATE_UNIT_ALLOWIMAGE),
  updateUnitAllowVideo: makeAction(types.UPDATE_UNIT_ALLOWVIDEO),
  updateUnitAllowZip: makeAction(types.UPDATE_UNIT_ALLOWZIP),
  updateUnitAllowAudio: makeAction(types.UPDATE_UNIT_ALLOWAUDIO),
  updateUnitBlockUniqueAdvertiserIDs: makeAction(types.UPDATE_UNIT_BLOCKUNIQUEADVERTISERIDS),
  updateUnitDealAvailability: makeAction(types.UPDATE_UNIT_DEAL_AVAILABILITY),
  updateUnitDescription: makeAction(types.UPDATE_UNIT_DESCRIPTION),
  updateUnitEnableStrictIABCategoriesBlocking: makeAction(types.UPDATE_UNIT_ENABLE_STRICT_IAB_BLOCK_CATEGORIES),
  updateUnitEnableStrictIABFrequencyCapping: makeAction(types.UPDATE_UNIT_ENABLE_STRICT_FREQUENCY_CAPPING),
  updateUnitExternalID: makeAction(types.UPDATE_UNIT_EXTERNALID),
  updateUnitFacingDirection: makeAction(types.UPDATE_UNIT_FACING_DIRECTION),
  updateUnitFallbackCreatives: makeAction(types.UPDATE_UNIT_FALLBACK_CREATIVES),
  updateUnitFloorCPM: makeAction(types.UPDATE_UNIT_FLOORCPM),
  updateUnitGeofence: makeAction(types.UPDATE_UNIT_GEOFENCE),
  updateUnitIABBlockCategories: makeAction(types.UPDATE_UNIT_IAB_BLOCK_CATEGORIES),
  updateUnitImageUri: makeAction(types.UPDATE_UNIT_IMAGE_URI),
  updateUnitImpressionVerifierVendor: makeAction(types.UPDATE_UNIT_IMPRESSION_VERIFIER_VENDOR),
  updateUnitImpressionVerifierVendorExternalId: makeAction(types.UPDATE_UNIT_IMPRESSION_VERIFIER_VENDOR_EXTERNAL_ID),
  updateUnitIsActive: makeAction(types.UPDATE_UNIT_ISACTIVE),
  updateUnitIsStreetViewImageAvailable: makeAction(types.UPDATE_UNIT_ISSTREETVIEWIMAGEAVAILABLE),
  updateUnitLatitude: makeAction(types.UPDATE_UNIT_LATITUDE),
  updateUnitLocationID: makeAction(types.UPDATE_UNIT_LOCATIONID),
  updateUnitLongitude: makeAction(types.UPDATE_UNIT_LONGITUDE),
  updateUnitLoopLength: makeAction(types.UPDATE_UNIT_LOOPLENGTH),
  updateUnitMaxSpotLength: makeAction(types.UPDATE_UNIT_MAX_SPOTLENGTH),
  updateUnitMediaTypeID: makeAction(types.UPDATE_UNIT_MEDIATYPEID),
  updateUnitMinSecondsBetweenAdDomainPlays: makeAction(types.UPDATE_UNIT_MIN_SECONDS_BETWEEN_AD_DOMAIN_PLAYS),
  updateUnitMinSecondsBetweenIABCategoryPlays: makeAction(types.UPDATE_UNIT_MIN_SECONDS_BETWEEN_IAB_CATEGORY_PLAYS),
  updateUnitMinSpotLength: makeAction(types.UPDATE_UNIT_MIN_SPOTLENGTH),
  updateUnitName: makeAction(types.UPDATE_UNIT_NAME),
  updateUnitNetworkID: makeAction(types.UPDATE_UNIT_NETWORKID),
  updateUnitOpenExchangeAvailability: makeAction(types.UPDATE_UNIT_OPEN_EXCHANGE_AVAILABILITY),
  updateUnitOperatingHours: makeAction(types.UPDATE_UNIT_OPERATINGHOURS),
  updateUnitPhysicalScreenHeight: makeAction(types.UPDATE_UNIT_PHYSICAL_SCREEN_HEIGHT),
  updateUnitPhysicalScreenWidth: makeAction(types.UPDATE_UNIT_PHYSICAL_SCREEN_WIDTH),
  updateUnitProperties: makeAction(types.UPDATE_UNIT_PROPERTIES),
  updateUnitScreenHeight: makeAction(types.UPDATE_UNIT_SCREENHEIGHT),
  updateUnitScreenWidth: makeAction(types.UPDATE_UNIT_SCREENWIDTH),
  updateUnitSite: makeAction(types.UPDATE_UNIT_SITE),
  updateUnitSiteID: makeAction(types.UPDATE_UNIT_SITEID),
  updateUnitSpotLength: makeAction(types.UPDATE_UNIT_SPOTLENGTH),
  updateUnitTags: makeAction(types.UPDATE_UNIT_TAGS),
  updateUnitStoreFrontAvailability: makeAction(types.UPDATE_UNIT_STORE_FRONT_AVIALABILTY),
  updateUnitTimezone: makeAction(types.UPDATE_UNIT_TIMEZONE),
  updateUnitUnitLanguages: makeAction(types.UPDATE_UNIT_UNITLANGUAGES),
  updateUnitUuid: makeAction(types.UPDATE_UNIT_UUID),
  updateUnitPhysicalUnitCount: makeAction(types.UPDATE_UNIT_PHYSICAL_UNIT_COUNT),
  updateUnitHasPhysicalUnitCount: makeAction(types.UPDATE_UNIT_HAS_PHYSICAL_UNIT_COUNT),

  // UNIT PACKS
  updateUnitPackDescription: makeAction(types.UPDATE_UNITPACK_DESCRIPTION),
  updateUnitPackName: makeAction(types.UPDATE_UNITPACK_NAME),
  updateUnitPackIsActive: makeAction(types.UPDATE_UNITPACK_ISACTIVE),
  updateUnitPackExternalID: makeAction(types.UPDATE_UNITPACK_EXTERNALID),

  // USER
  updateUserProfilePicture: makeAction(types.UPDATE_USER_PROFILEPICTURE),

  // USER ORGANIZATIONS
  updateUserOrganizationRoleID: makeAction(types.UPDATE_USER_ORGANIZATION_ROLEID),

  // USER UI SETTINGS
  updateUserSettingKey: makeAction(types.UPDATE_USERSETTING_KEY),
  updateUserSettingValue: makeAction(types.UPDATE_USERSETTING_VALUE),

  // USER PROFILE
  updateUserProfileDisplayName: makeAction(types.UPDATE_USERPROFILE_DISPLAYNAME),
};

export default actions;
